<template>
  <CircleCheck v-if="value" :size="size" class="text-success" />
  <CircleX v-else :size="size" class="text-danger" />
</template>

<script>
import { CircleCheck, CircleX } from 'lucide-vue';

export default {
  name: 'CustomIconChecked',
  components: { CircleCheck, CircleX },
  props: {
    value: {
      type: [Boolean, null],
    },
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>
